<ng-template #cartModal>
  <div class="offcanvas-header pb-0">
    <h4 class="modal-title mt-0">{{ "heading-title.cart" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  @if(cartDetails && (cartDetails.availableProducts.length || cartDetails.unavailableProducts.length)){ @if(citySetting && citySetting.businessSequence.length > 1 &&
  isDeliveryBusiness){ @if(merchantSetting && merchantSetting.bookingTypes.includes(helper.BookingType.DELIVERY) &&
  merchantSetting.bookingTypes.includes(helper.BookingType.PICKUP)){
  <div class="d-flex justify-content-end p-3">
    <div class="btn-group" role="group" aria-label="Basic example">
      <button type="button" class="btn" [ngClass]="{ 'btn-dark': isDeliveryActive, 'btn-light': !isDeliveryActive }" (click)="toggleDelivery()">
        {{ "button-title.delivery" | translate }}
      </button>
      <button type="button" class="btn" [ngClass]="{ 'btn-dark': !isDeliveryActive, 'btn-light': isDeliveryActive }" (click)="togglePickup()">
        {{ "button-title.pickup" | translate }}
      </button>
    </div>
  </div>
  } } @if(citySetting && citySetting.businessSequence.length > 1 && isServicesBusiness){ @if(serviceMainCategory &&
  serviceMainCategory.bookingTypes.includes(helper.BookingType.SERVICE_AT_HOME) && serviceMainCategory.bookingTypes.includes(helper.BookingType.ON_SITE_SERVICE)){
  <div class="d-flex justify-content-end p-3">
    <div class="btn-group" role="group" aria-label="Basic example">
      <button
        type="button"
        class="btn"
        [ngClass]="selectedBookingType === helper.BookingType.SERVICE_AT_HOME ? 'btn-dark' : 'btn-light'"
        (click)="toggleServiceBookingType(helper.BookingType.SERVICE_AT_HOME)"
      >
        {{ "button-title.at-home" | translate }}
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="selectedBookingType === helper.BookingType.ON_SITE_SERVICE ? 'btn-dark' : 'btn-light'"
        (click)="toggleServiceBookingType(helper.BookingType.ON_SITE_SERVICE)"
      >
        {{ "button-title.on-site" | translate }}
      </button>
    </div>
  </div>
  } } @if(citySetting && citySetting.businessSequence.length > 1 && isDeliveryBusiness){
  <!-- Case 1: Merchant only supports DELIVERY -->
  @if(merchantSetting && merchantSetting.bookingTypes.includes(helper.BookingType.DELIVERY) && !merchantSetting.bookingTypes.includes(helper.BookingType.PICKUP)) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-delivery-location" | translate }}
  </span>
  }

  <!-- Case 2: Merchant only supports PICKUP -->
  @if(merchantSetting && merchantSetting.bookingTypes.includes(helper.BookingType.PICKUP) && !merchantSetting.bookingTypes.includes(helper.BookingType.DELIVERY)) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-pickup-location" | translate }}
  </span>
  } }

  <!-- Case 4: City only supports DELIVERY -->
  @if(citySetting && citySetting.businessSequence.length === 1 && citySetting.businessSequence.includes("DELIVERY")) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-delivery-location" | translate }}
  </span>
  }

  <!-- Case 5: City only supports PICKUP -->
  @if(citySetting && citySetting.businessSequence.length === 1 && citySetting.businessSequence.includes("PICKUP")) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-pickup-location" | translate }}
  </span>
  }

  <!-- Case 6: City only supports ON_SITE_SERVICE -->
  @if(citySetting && citySetting.businessSequence.length === 1 && citySetting.businessSequence.includes("ON_SITE_SERVICE")) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-on-site-service-location" | translate }}
  </span>
  }

  <!-- Case 7: City only supports SERVICE_AT_HOME -->
  @if(citySetting && citySetting.businessSequence.length === 1 && citySetting.businessSequence.includes("SERVICE_AT_HOME")) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-service-at-home-location" | translate }}
  </span>
  } @if(citySetting && citySetting.businessSequence.length > 1 && isServicesBusiness){
  <!-- Case 8: Main Category only supports SERVICE_AT_HOME -->
  @if(serviceMainCategory && serviceMainCategory.bookingTypes.includes(helper.BookingType.SERVICE_AT_HOME) &&
  !serviceMainCategory.bookingTypes.includes(helper.BookingType.ON_SITE_SERVICE)) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-service-at-home-location" | translate }}
  </span>
  }

  <!-- Case 9: Main Category only supports ON_SITE_SERVICE -->
  @if(serviceMainCategory && !serviceMainCategory.bookingTypes.includes(helper.BookingType.SERVICE_AT_HOME) &&
  serviceMainCategory.bookingTypes.includes(helper.BookingType.ON_SITE_SERVICE)) {
  <span class="text-danger text-center mb-2 fs-5">
    {{ "label-title.only-on-site-service-location" | translate }}
  </span>
  } }

  <!-- Case 10: Merchant does not provide delivery location -->
  @if(cartDetails && !cartDetails.isLocationInsideDeliveryZone && (helper.route.url.includes("/users/create-booking/e-delivery"))){
  <span class="text-danger text-center mb-2 fs-5">{{ "label-title.error_store_not_provide_delivery_location_sd" | translate }}</span>
  } @if(isServicesBusiness && selectedBookingType === helper.BookingType.ON_SITE_SERVICE){
  <div class="px-3">
    @if(serviceMainCategory && serviceMainCategory.serviceSetting?.isAllowPickupFromHome){
    <div class="form-check form-check-primary mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="pick-at-my-location"
        [(ngModel)]="isPickAtMyLocation"
        [ngModelOptions]="{ standalone: true }"
        (change)="onPickAtMyLocationChange()"
      />
      <label class="form-check-label" for="pick-at-my-location">{{ "label-title.pick-at-my-location" | translate }}</label>
    </div>
    } @if(serviceMainCategory && serviceMainCategory.serviceSetting?.isAllowDropAtHome){
    <div class="form-check form-check-primary mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="drop-at-my-location"
        [(ngModel)]="isDropAtMyLocation"
        [ngModelOptions]="{ standalone: true }"
        (change)="onDropAtMyLocationChange()"
      />
      <label class="form-check-label" for="drop-at-my-location">{{ "label-title.drop-at-my-location" | translate }}</label>
    </div>
    }
  </div>
  }

  <div [ngClass]="isDeliveryBusiness ? 'pb-2' : 'py-2'">
    <div class="address d-flex gap-3 align-items-center p-3 fw-medium">
      <img
        [src]="
          !isDeliveryBusiness && !isServicesBusiness
            ? 'assets/images/default-images/timer.svg'
            : isServicesBusiness
            ? 'assets/images/default-images/company.svg'
            : isDeliveryBusiness && isDeliveryActive
            ? 'assets/images/default-images/delivery.svg'
            : 'assets/images/default-images/pickup.svg'
        "
        alt=""
        height="60"
        width="60"
      />
      @if (helper.route.url.includes("/users/create-booking/e-delivery") && cartDetails) {
      <div (click)="handleAddressClick()" [ngClass]="isDeliveryActive && helper.userToken ? 'd-flex align-items-center cursor-pointer' : ''">
        <span>{{ isDeliveryActive ? currentDeliveryAddress.address : cartDetails.merchantDetail.address }}</span>
        @if(isDeliveryActive && helper.userToken){
        <i class="ri-arrow-down-s-fill ri-2x"></i>
        }
      </div>
      } @else if (helper.route.url.includes("/users/create-booking/quick-commerce") && cartDetails) {
      <div>
        <h5 clas="mb-0">{{ "label-title.delivery-in" | translate }} {{ cartDetails.totalTimeToDeliver / 60 | number : "1.0-0" }} {{ "label-title.minutes" | translate }}</h5>
        <div (click)="handleAddressClick()" [ngClass]="helper.userToken ? 'd-flex align-items-center cursor-pointer' : ''">
          <span>{{ currentDeliveryAddress.address }}</span>
          @if(helper.userToken){
          <i class="ri-arrow-down-s-fill ri-2x"></i>
          }
        </div>
      </div>
      } @else if(isServicesBusiness){
      <div
        (click)="handleAddressClick()"
        [ngClass]="
          helper.userToken && (selectedBookingType === helper.BookingType.SERVICE_AT_HOME || isDropAtMyLocation || isPickAtMyLocation)
            ? 'd-flex align-items-center cursor-pointer'
            : ''
        "
      >
        <span>{{
          selectedBookingType === helper.BookingType.SERVICE_AT_HOME || isDropAtMyLocation || isPickAtMyLocation
            ? currentDeliveryAddress.address
            : entityType && cartDetails.merchantDetail.address && !isPickAtMyLocation && !isDropAtMyLocation
            ? cartDetails.merchantDetail.address
            : ("label-title.merchant-address-later" | translate)
        }}</span>
        @if(helper.userToken && (selectedBookingType === helper.BookingType.SERVICE_AT_HOME || isDropAtMyLocation || isPickAtMyLocation)){
        <i class="ri-arrow-down-s-fill ri-2x"></i>
        }
      </div>
      }
    </div>
    @if(helper.route.url.includes("/users/create-booking/e-delivery") && cartDetails){ @if(!cartDetails.merchantDetail.isOpen){
    <div class="px-3">
      <div class="d-flex flex-column w-30 mx-auto">
        <img src="assets/images/default-images/hanging-angle.svg" alt="" class="w-60 mx-auto" />
        <button class="btn closed-button text-white">
          <i class="ri-emotion-unhappy-fill ri-lg me-1"></i>
          {{ "label-title.closed" | translate }}
        </button>
      </div>
      @if(cartDetails.merchantDetail.nextOpenTime){
      <p class="reopen-text mt-1 text-center mb-0">{{ "label-title.reopens-at" | translate }} {{ cartDetails.merchantDetail.nextOpenTime | date : "EEE hh.mm a" }}</p>
      }
    </div>
    } }
  </div>

  <div class="offcanvas-body-container">
    @if(helper.route.url.includes("/users/create-booking/e-delivery") && cartDetails){
    <div class="align-items-center d-flex justify-content-between p-3">
      <span class="merchant-name w-70">{{ cartDetails.merchantDetail.name | translate }}</span>
      <button class="btn bg-danger-subtle text-danger fw-medium" (click)="addMoreProducts(helper.BusinessType.DELIVERY)">{{ "button-title.add-more" | translate }}</button>
    </div>
    } @else if(isServicesBusiness && cartDetails && typeId) {
    <div class="align-items-center d-flex justify-content-between p-3">
      <span class="merchant-name w-70">{{ cartDetails.merchantDetail.name | translate }}</span>
      <button class="btn bg-danger-subtle text-danger fw-medium" (click)="changeServiceProvider()">{{ "button-title.change" | translate }}</button>
    </div>
    } @else if(helper.route.url.includes("/users/create-booking/services") && cartDetails && cartDetails.merchantDetail){
    <div class="align-items-center d-flex justify-content-between p-3">
      <span class="merchant-name w-70">{{ cartDetails.merchantDetail.name | translate }}</span>
      <button class="btn bg-danger-subtle text-danger fw-medium" (click)="addMoreProducts(helper.BusinessType.SERVICE)">{{ "button-title.add-more" | translate }}</button>
    </div>
    }@if(cartDetails && cartDetails.unavailableProducts && cartDetails.unavailableProducts.length > 0){
    <div class="out-of-stock-container">
      <div class="px-3 pt-2 d-flex justify-content-between align-items-center">
        <span class="fs-22 font-weight-semibold title">{{ "label-title.item-out-of-stock" | translate }}</span>
        <i class="ri-close-fill ri-2x cursor-pointer text-danger" (click)="removeUnavailableProducts()"></i>
      </div>
      <div class="p-3 divider">
        @for(item of cartDetails.unavailableProducts; track $index) {
        <ng-container *ngTemplateOutlet="cartItem; context: { item: item, isOutOfStock: true }"></ng-container>
        }
      </div>
    </div>
    } @if(cartDetails && cartDetails.availableProducts && cartDetails.availableProducts.length > 0){
    <!-- Cart Items -->
    <div
      class="p-3 divider"
      [ngClass]="{
        'opacity-50 pointer-events-none':
          helper.route.url.includes('/users/create-booking/e-delivery') &&
          (!(cartDetails.merchantDetail && cartDetails.merchantDetail.isOpen) || !cartDetails.isLocationInsideDeliveryZone)
      }"
    >
      @for(item of cartDetails.availableProducts; track $index) {
      <ng-container *ngTemplateOutlet="cartItem; context: { item: item, isOutOfStock: false }"></ng-container>
      }
    </div>

    @if((helper.route.url.includes('/users/create-booking/quick-commerce') && cartDetails) || (helper.route.url.includes('/users/create-booking/services') && cartDetails) ||
    (cartDetails && cartDetails.merchantDetail && cartDetails.merchantDetail.isOpen && cartDetails.isLocationInsideDeliveryZone)){
    <!-- Promo Code -->
    @if(isAllowPromoCode() && selectedPaymentMethod && helper.userToken){
    <div class="promo-code divider p-3">
      <h5 class="mb-3">{{ "heading-title.promo-code" | translate | uppercase }}</h5>
      @if(appliedPromo && appliedPromo.code){
      <div class="apply-promo px-3 py-2">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h6 class="fs-14 mb-0">{{ appliedPromo.code }}</h6>
          <a href="javascript:void(0);" (click)="removeAppliedPromo()">
            <i class="ri-delete-bin-5-fill fs-16"></i>
          </a>
        </div>
        <div class="d-flex align-items-center">
          <img src="../../../../assets/images/default-images/offers.svg" alt="offer" width="15px" />
          <span class="d-flex flex-wrap text-muted ms-2 fs-11">
            {{ "label-title.applied-promo-code-is-valid-and-you-have-ordered-more-than" | translate }}
            <span class="d-flex currency-gap mx-1">
              {{ appliedPromo.value ? appliedPromo.value.toFixed(helper.adminSettings.decimalPointValue) : 0 }}
              @if (appliedPromo.priceType && appliedPromo.priceType == helper.PriceSign.ABSOLUTE) {
              <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ helper.currencySign }}
              </span>
              } @else { % }
            </span>
            {{ "label-title.on-your-curent-ride" | translate }}
          </span>
        </div>
      </div>
      } @else {
      <a href="javascript:void(0);" (click)="openPromoCodeModal($event)" class="apply-promo text-muted d-flex justify-content-between align-items-center p-2 c-pointer">
        {{ "label-title.apply-promo" | translate }}
        <i class="las la-long-arrow-alt-right fs-16 ms-1"></i>
      </a>
      }
    </div>
    }

    <!-- Billing Details -->
    <div class="billing-details divider p-3">
      <h5 class="mb-3">{{ "heading-title.billing-details" | translate | uppercase }}</h5>
      <div class="billing-details-list p-3">
        <div>
          <div class="d-flex flex-column gap-2">
            @for(charge of cartDetails.charges; track $index) {
            <div class="d-flex justify-content-between align-items-center">
              @if(charge.title === helper.PriceParamEnum.offerBonus){
              <div class="d-flex align-items-center gap-2 cursor-pointer" (click)="toggleOfferVisibility()">
                <span>{{ helper.PriceParamEnumString[charge.title] | translate }}</span>
                <i [ngClass]="isShowDiscountDetails ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
              </div>
              } @else if(charge.title === helper.PriceParamEnum.deliveryPrice){
              <div class="d-flex align-items-center gap-2 cursor-pointer" (click)="toggleDeliveryPriceVisibility()">
                <span>{{ helper.PriceParamEnumString[charge.title] | translate }}</span>
                <i [ngClass]="isShowDiscountDetails ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
              </div>
              } @else {
              <span>{{ helper.PriceParamEnumString[charge.title] | translate }}</span>
              }
              <div class="d-flex align-items-center gap-2">
                @if(charge.discountedPrice === 0){
                <div class="free-tag d-inline-flex align-items-center">
                  <span class="free-text">{{ "label-title.free" | translate }}</span>
                </div>
                }
                <div class="d-flex align-items-center gap-2">
                  @if(charge.discountedPrice){
                  <div class="d-flex ms-1 align-items-center">
                    <span class="current-price">
                      {{ charge.discountedPrice.toFixed(cartDetails.decimalPointValue) }}
                    </span>
                    <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                      {{ charge.discountedPrice ? helper.currencySign : "" }}
                    </span>
                  </div>
                  } @if((charge.discountedPrice !== charge.price)){
                  <div class="d-flex ms-1 align-items-center">
                    <span class="original-price">
                      {{ charge.price.toFixed(cartDetails.decimalPointValue) }}
                    </span>
                    <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="original-price">
                      {{ charge.price ? helper.currencySign : "" }}
                    </span>
                  </div>
                  }
                </div>
              </div>
            </div>
            @if(charge.title === helper.PriceParamEnum.offerBonus && isShowDiscountDetails){ @for(offer of cartDetails.appliedOffer; track offer.offerId; let i = $index){
            <div class="d-flex justify-content-between align-items-center">
              <span class="charge-description">{{ offer.title | translate }}</span>
              <div class="d-flex ms-1 align-items-center">
                <span class="charge-description">
                  {{ offer.discount.toFixed(cartDetails.decimalPointValue) }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="charge-description">
                  {{ offer.discount ? helper.currencySign : "" }}
                </span>
              </div>
            </div>
            } } @if(charge.title === helper.PriceParamEnum.deliveryPrice && isShowDeliveryPriceDetails){ @for(charge of charge.childs; track $index){ @if(charge.discountedPrice){
            <div class="d-flex justify-content-between align-items-center">
              <span class="charge-description">{{ helper.PriceParamEnumString[charge.title] | translate }}</span>
              <div class="d-flex ms-1 align-items-center">
                <span class="charge-description">
                  {{ charge.discountedPrice.toFixed(cartDetails.decimalPointValue) }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="charge-description">
                  {{ charge.discountedPrice ? helper.currencySign : "" }}
                </span>
              </div>
            </div>
            } } } } @for(additionalPrice of cartDetails.additionalPrices; track $index){
            <div class="d-flex justify-content-between align-items-center">
              <span>
                {{ additionalPrice.title | translate }}
              </span>
              <div class="d-flex align-items-center gap-2">
                <div class="d-flex ms-1 align-items-center">
                  <span class="current-price">
                    {{ additionalPrice.discountedPrice.toFixed(cartDetails.decimalPointValue) }}
                  </span>
                  <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                    {{ additionalPrice.discountedPrice ? helper.currencySign : "" }}
                  </span>
                </div>
              </div>
            </div>
            } @for(taxPrice of cartDetails.taxPrices; track $index){
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ taxPrice.title | translate }}</span>
              <div class="d-flex align-items-center gap-2">
                <div class="d-flex ms-1 align-items-center">
                  <span class="current-price">
                    {{ taxPrice.discountedPrice.toFixed(cartDetails.decimalPointValue) }}
                  </span>
                  <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                    {{ taxPrice.discountedPrice ? helper.currencySign : "" }}
                  </span>
                </div>
                @if(taxPrice.discountedPrice !== taxPrice.price){
                <div class="d-flex ms-1 align-items-center">
                  <span class="original-price">
                    {{ taxPrice.price.toFixed(cartDetails.decimalPointValue) }}
                  </span>
                  <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="original-price">
                    {{ taxPrice.price ? helper.currencySign : "" }}
                  </span>
                </div>
                }
              </div>
            </div>
            <span class="charge-description">{{ taxPrice.unit }}%</span>
            @if (taxPrice.filteredAppliedOn.length > 0) {
            <span class="charge-description">
              {{ "label-title.applied-on" | translate }} ( @for (title of taxPrice.filteredAppliedOn; track title; let i = $index) {
              {{ helper.PriceParamEnumString[title] | translate }}
              @if (i < taxPrice.filteredAppliedOn.length - 1) {, } } )
            </span>
            } }
          </div>
          <div class="total-amount">
            <span>{{ "label-title.total" | translate }}</span>
            <div class="d-flex ms-1 align-items-center">
              <span class="current-price">
                {{ cartDetails.total.toFixed(cartDetails.decimalPointValue) }}
              </span>
              <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ cartDetails.total ? helper.currencySign : "" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if(isAllowTip() && helper.userToken){
    <!-- Tip Section -->
    <div class="tip-section divider p-3">
      <h5 class="mb-3">{{ "heading-title.tip-your-deliveryman" | translate | uppercase }}</h5>
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <div class="d-flex flex-wrap gap-2">
          @for(price of tipPrices; track $index){
          <button class="btn" (click)="addTip(price, $index)" [ngClass]="selectedTipPriceIndex === $index ? 'btn-primary' : 'btn-outline-primary'">
            <div class="d-flex ms-1 align-items-center">
              <span class="current-price">
                {{ price.toFixed(cartDetails.decimalPointValue) }}
              </span>
              <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ helper.currencySign }}
              </span>
            </div>
          </button>
          }
        </div>
        <!-- Manual Tip Input -->
        <div class="d-flex align-items-center">
          <div class="position-relative d-flex align-items-center">
            <input type="number" class="form-control" [(ngModel)]="manualTipAmount" placeholder="Enter tip amount" (input)="onTipInputChange()" />
            <!-- Clear (X) Icon - Show only when manualTipAmount has a value -->
            @if(manualTipAmount){
            <i class="ri-close-fill fs-5 text-muted position-absolute end-0 pe-1" (click)="clearManualTip()"></i>
            }
          </div>
          <button class="btn btn-dark ms-2" (click)="applyManualTip()">{{ "button-title.apply" | translate }}</button>
        </div>
      </div>
    </div>
    }

    <!-- <div class="d-flex align-items-center p-3">
            <img src="assets/images/default-images/privacy-policy.png" alt="" />
            <div class="d-flex align-items-center justify-content-between w-100">
              <a href="#" class="text-danger fs-5 fw-semibold">View Cancellation Policy</a>
              <i class="ri-arrow-right-s-fill ri-2x text-danger"></i>
            </div>
          </div> -->

    @if(helper.userToken){
    <div class="divider p-3">
      <h5>{{ "heading-title.choose-payment-option" | translate | uppercase }}</h5>
      @if(selectedPaymentMethod){
      <a href="javascript:void(0)" class="mt-3 bg-light text-muted payment-selection-option border-radius-12" (click)="openBookingPaymentModal()">
        <span>{{ helper.PaymentModeStrings[selectedPaymentMethod] | translate }}</span>
        <span class="text-primary">
          @if(selectedPaymentMethod == helper.PaymentMode.Cash){
          <svg width="32" height="32" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_17182_775)">
              <path
                d="M39.5833 8.33337H10.4167C7.65501 8.33668 5.00741 9.43521 3.05462 11.388C1.10184 13.3408 0.00330804 15.9884 0 18.75L0 31.25C0.00330804 34.0117 1.10184 36.6593 3.05462 38.6121C5.00741 40.5649 7.65501 41.6634 10.4167 41.6667H39.5833C42.345 41.6634 44.9926 40.5649 46.9454 38.6121C48.8982 36.6593 49.9967 34.0117 50 31.25V18.75C49.9967 15.9884 48.8982 13.3408 46.9454 11.388C44.9926 9.43521 42.345 8.33668 39.5833 8.33337ZM8.33333 35.4167C7.92129 35.4167 7.5185 35.2945 7.1759 35.0656C6.83329 34.8367 6.56627 34.5113 6.40858 34.1306C6.2509 33.75 6.20964 33.3311 6.29003 32.9269C6.37042 32.5228 6.56883 32.1516 6.86019 31.8602C7.15155 31.5689 7.52277 31.3705 7.9269 31.2901C8.33102 31.2097 8.74991 31.2509 9.13059 31.4086C9.51127 31.5663 9.83664 31.8333 10.0656 32.1759C10.2945 32.5185 10.4167 32.9213 10.4167 33.3334C10.4167 33.8859 10.1972 34.4158 9.80647 34.8065C9.41577 35.1972 8.88587 35.4167 8.33333 35.4167ZM8.33333 18.75C7.92129 18.75 7.5185 18.6279 7.1759 18.3989C6.83329 18.17 6.56627 17.8446 6.40858 17.464C6.2509 17.0833 6.20964 16.6644 6.29003 16.2603C6.37042 15.8561 6.56883 15.4849 6.86019 15.1936C7.15155 14.9022 7.52277 14.7038 7.9269 14.6234C8.33102 14.543 8.74991 14.5843 9.13059 14.742C9.51127 14.8996 9.83664 15.1667 10.0656 15.5093C10.2945 15.8519 10.4167 16.2547 10.4167 16.6667C10.4167 17.2192 10.1972 17.7491 9.80647 18.1398C9.41577 18.5305 8.88587 18.75 8.33333 18.75ZM25 33.3334C23.3518 33.3334 21.7407 32.8446 20.3702 31.929C18.9998 31.0133 17.9317 29.7118 17.301 28.1891C16.6703 26.6664 16.5052 24.9908 16.8268 23.3743C17.1483 21.7578 17.942 20.2729 19.1074 19.1075C20.2729 17.942 21.7577 17.1484 23.3742 16.8268C24.9908 16.5053 26.6663 16.6703 28.189 17.301C29.7117 17.9318 31.0132 18.9999 31.9289 20.3703C32.8446 21.7407 33.3333 23.3519 33.3333 25C33.3333 27.2102 32.4554 29.3298 30.8926 30.8926C29.3298 32.4554 27.2101 33.3334 25 33.3334ZM41.6667 35.4167C41.2546 35.4167 40.8518 35.2945 40.5092 35.0656C40.1666 34.8367 39.8996 34.5113 39.7419 34.1306C39.5842 33.75 39.543 33.3311 39.6234 32.9269C39.7037 32.5228 39.9022 32.1516 40.1935 31.8602C40.4849 31.5689 40.8561 31.3705 41.2602 31.2901C41.6644 31.2097 42.0832 31.2509 42.4639 31.4086C42.8446 31.5663 43.17 31.8333 43.3989 32.1759C43.6278 32.5185 43.75 32.9213 43.75 33.3334C43.75 33.8859 43.5305 34.4158 43.1398 34.8065C42.7491 35.1972 42.2192 35.4167 41.6667 35.4167ZM41.6667 18.75C41.2546 18.75 40.8518 18.6279 40.5092 18.3989C40.1666 18.17 39.8996 17.8446 39.7419 17.464C39.5842 17.0833 39.543 16.6644 39.6234 16.2603C39.7037 15.8561 39.9022 15.4849 40.1935 15.1936C40.4849 14.9022 40.8561 14.7038 41.2602 14.6234C41.6644 14.543 42.0832 14.5843 42.4639 14.742C42.8446 14.8996 43.17 15.1667 43.3989 15.5093C43.6278 15.8519 43.75 16.2547 43.75 16.6667C43.75 17.2192 43.5305 17.7491 43.1398 18.1398C42.7491 18.5305 42.2192 18.75 41.6667 18.75ZM29.1667 25C29.1667 25.8241 28.9223 26.6297 28.4645 27.3149C28.0066 28.0001 27.3559 28.5342 26.5945 28.8495C25.8332 29.1649 24.9954 29.2474 24.1871 29.0866C23.3789 28.9259 22.6364 28.529 22.0537 27.9463C21.471 27.3636 21.0742 26.6212 20.9134 25.8129C20.7526 25.0047 20.8351 24.1669 21.1505 23.4055C21.4659 22.6442 21.9999 21.9934 22.6851 21.5356C23.3703 21.0777 24.1759 20.8334 25 20.8334C26.1051 20.8334 27.1649 21.2724 27.9463 22.0538C28.7277 22.8352 29.1667 23.895 29.1667 25Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_17182_775">
                <rect width="50" height="50" fill="white" />
              </clipPath>
            </defs>
          </svg>
          }@else{
          <svg width="32" height="32" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7346_2071)">
              <path
                d="M39.5833 6.25H10.4167C7.65501 6.25331 5.00741 7.35184 3.05462 9.30463C1.10184 11.2574 0.00330804 13.905 0 16.6667H50C49.9967 13.905 48.8982 11.2574 46.9454 9.30463C44.9926 7.35184 42.345 6.25331 39.5833 6.25Z"
                fill="currentColor"
              />
              <path
                d="M0 33.3333C0.00330804 36.0949 1.10184 38.7425 3.05462 40.6953C5.00741 42.6481 7.65501 43.7466 10.4167 43.7499H39.5833C42.345 43.7466 44.9926 42.6481 46.9454 40.6953C48.8982 38.7425 49.9967 36.0949 50 33.3333V20.8333H0V33.3333ZM14.5833 32.2916C14.5833 32.9097 14.4001 33.5138 14.0567 34.0277C13.7133 34.5416 13.2252 34.9422 12.6542 35.1787C12.0832 35.4152 11.4549 35.4771 10.8487 35.3565C10.2425 35.236 9.68566 34.9383 9.24862 34.5013C8.81158 34.0643 8.51396 33.5074 8.39338 32.9012C8.2728 32.2951 8.33469 31.6667 8.57121 31.0957C8.80773 30.5247 9.20827 30.0366 9.72218 29.6932C10.2361 29.3499 10.8403 29.1666 11.4583 29.1666C12.2871 29.1666 13.082 29.4958 13.668 30.0819C14.2541 30.6679 14.5833 31.4628 14.5833 32.2916Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_7346_2071">
                <rect width="50" height="50" fill="white" />
              </clipPath>
            </defs>
          </svg>
          }
        </span>
      </a>
      } @else {
      <a href="javascript:void(0);" (click)="openBookingPaymentModal()" class="select-payment-option text-muted d-flex justify-content-between align-items-center p-2 c-pointer">
        {{ "label-title.select-payment-method" | translate }}
        <i class="las la-long-arrow-alt-right fs-16 ms-1"></i>
      </a>
      } @if (isPaymentOptionError) {
      <div class="invalid-message">
        {{ "label-title.please-add-card" | translate }}
      </div>
      } @if(selectedPaymentMethod === helper.PaymentMode.Wallet){ @if(cartDetails.total > availableWalletBalance){
      <div class="invalid-message">
        {{ "validation-title.insufficient-wallet-balance" | translate }}
      </div>
      } }
    </div>
    @if((isDeliveryActive && isDeliveryBusiness) || (isServicesBusiness && selectedBookingType === helper.BookingType.SERVICE_AT_HOME)){
    <div class="mb-3 p-3" [ngClass]="{ divider: categoryGroups && categoryGroups.length > 0 }">
      <h5>{{ "heading-title.message" | translate | uppercase }}</h5>
      <div class="d-flex gap-2 align-items-center">
        <div class="text-primary">
          <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.1555 8.3849L15.1551 10.7966C15.1543 13.6116 15.1545 15.0195 14.6052 16.0846C14.1718 16.9255 13.5078 17.6143 12.6971 18.064C12.5951 18.1211 12.4901 18.1714 12.3814 18.2166C11.3878 18.6338 10.0433 18.6341 7.59737 18.6347C4.88265 18.6337 3.52488 18.634 2.49773 18.0644C1.68657 17.6147 1.02219 16.9258 0.588594 16.0846C0.0388043 15.0191 0.0388282 13.6124 0.0396983 10.7973L0.0389371 8.38596L0.0406281 7.25584C0.0502835 5.17359 0.117998 4.01015 0.588583 3.09675C1.02221 2.25629 1.6863 1.56791 2.49697 1.11856C3.52453 0.548453 4.8823 0.548166 7.59813 0.548756C10.3114 0.548805 11.6692 0.548518 12.696 1.117C13.5075 1.56691 14.172 2.25629 14.6055 3.09792C15.1553 4.16344 15.1553 5.5702 15.1555 8.3849ZM3.89861 10.3767C3.89864 10.2579 3.92124 10.1403 3.96512 10.0306C4.00899 9.92088 4.07329 9.8212 4.15432 9.73724C4.23536 9.65329 4.33156 9.58672 4.43741 9.54133C4.54327 9.49593 4.65671 9.47261 4.77126 9.47269L10.5857 9.47363C10.7023 9.47012 10.8185 9.49093 10.9272 9.53481C11.036 9.5787 11.1351 9.64477 11.2188 9.72912C11.3025 9.81346 11.369 9.91436 11.4143 10.0258C11.4597 10.1373 11.4831 10.2571 11.483 10.3781C11.4829 10.4991 11.4594 10.6189 11.4139 10.7303C11.3684 10.8417 11.3018 10.9425 11.218 11.0268C11.1342 11.111 11.035 11.1769 10.9261 11.2207C10.8173 11.2644 10.7012 11.2851 10.5845 11.2814L4.77043 11.2816C4.53933 11.2815 4.31774 11.1862 4.15433 11.0168C3.99091 10.8473 3.89875 10.6164 3.89861 10.3767ZM3.89949 13.9951C3.89963 13.7555 3.9915 13.5257 4.15491 13.3562C4.31833 13.1868 4.53992 13.0915 4.77102 13.0914L8.25967 13.092C8.37668 13.0877 8.49332 13.1079 8.60264 13.1514C8.71195 13.195 8.81169 13.2608 8.89592 13.3452C8.98015 13.4295 9.04714 13.5306 9.09289 13.6423C9.13864 13.7541 9.16222 13.8743 9.16222 13.9957C9.16222 14.1171 9.13864 14.2373 9.09288 14.349C9.04713 14.4608 8.98014 14.5619 8.89592 14.6462C8.81169 14.7305 8.71194 14.7964 8.60263 14.8399C8.49331 14.8834 8.37667 14.9037 8.25966 14.8994L4.77131 14.9C4.65676 14.9 4.54334 14.8765 4.43752 14.831C4.33171 14.7855 4.23558 14.7189 4.15462 14.6348C4.07365 14.5508 4.00945 14.4511 3.96568 14.3413C3.9219 14.2315 3.89941 14.1139 3.89949 13.9951Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <input
          class="form-control"
          type="text"
          id="customerNote"
          [(ngModel)]="customerNote"
          autocomplete="off"
          [ngModelOptions]="{ standalone: true }"
          placeholder="{{ 'label-title.write-note' | translate }}"
        />
      </div>
    </div>
    } } } }
    <div>
      <app-category-group [categoryGroups]="categoryGroups" [merchantId]="merchantId" [isCart]="true"></app-category-group>
    </div>
  </div>
  @if(((helper.route.url.includes('/users/create-booking/quick-commerce') || isServicesBusiness) && cartDetails && cartDetails.availableProducts.length > 0) || (cartDetails &&
  cartDetails.merchantDetail && cartDetails.merchantDetail.isOpen && cartDetails.isLocationInsideDeliveryZone && cartDetails.availableProducts.length > 0)){
  <div class="offcanvas-footer">
    <button class="btn btn-dark w-100 d-flex justify-content-between" (click)="openCustomerDetailsModal()">
      <span>{{ "label-title.place-order" | translate }}</span>
      <div class="d-flex align-items-center gap-1">
        <span class="current-price">{{ cartDetails.total.toFixed(cartDetails.decimalPointValue) }}</span>
        <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign === helper.SetCurrencySignUnit.LEFT }">
          {{ cartDetails.total ? helper.currencySign : "" }}
        </span>
      </div>
    </button>
  </div>
  } } @if(cartDetails && (!cartDetails.availableProducts.length && !cartDetails.unavailableProducts.length)){
  <div class="d-flex justify-content-center align-items-center h-100">
    <h3>{{ "label-title.no-data-found" | translate }}</h3>
  </div>
  }
</ng-template>

<ng-template #cartItem let-item="item" let-isOutOfStock="isOutOfStock">
  <div
    class="cart-item"
    [ngClass]="{
      'opacity-50 pointer-events-none': isOutOfStock,
      'align-items-start': item.modifiers && item.modifiers.length > 0,
      'align-items-center': !item.modifiers || item.modifiers.length === 0
    }"
  >
    <img [src]="helper.imageUrl + item.imageUrl" class="cart-img" (error)="handleImageError($event)" />
    <div class="w-100">
      <div class="d-flex flex-column gap-1">
        <div class="d-flex justify-content-between">
          <div class="d-flex flex-column gap-1">
            @if(item.variantType === helper.VariantType.UNIT){
            <div class="product-tags">
              <span class="product-tag">{{ item.unit.unitValue }} {{ helper.UnitTypeString[item.unit.unitType] | translate }}</span>
            </div>
            } @else if (item.variantType === helper.VariantType.SIZE && item.unit.unitDescription){
            <div class="product-tags">
              <span class="product-tag">{{ item.unit.unitDescription | translate }}</span>
            </div>
            }
            <span class="product-name">{{ item.name | translate }}</span>
            <div class="d-flex flex-wrap gap-1">
              @for(discount of item.discounts; track $index){
              <div class="offer-badge d-flex align-items-center gap-1">
                @if(discount.discountTag){
                {{ discount.discountTag | translate }}
                } @else {
                {{ "label-title.off-qd" | translate : { _VALUE: helper.roundUpValue(discount.discountPercentage) } }}
                }
                <span class="offer-description"
                  >{{ "label-title.customer-saved" | translate : { _CURRENCY_SIGN: helper.currencySign } }}{{ discount.discount.toFixed(cartDetails.decimalPointValue) }}</span
                >
              </div>
              }
            </div>
          </div>
          <div class="d-flex flex-column gap-1">
            <div class="d-flex align-items-center gap-1 flex-wrap">
              @if(item.discountedPrice){
              <div class="d-flex ms-1 align-items-center">
                <span class="product-price ms-1">
                  {{ (item.discountedPrice * item.qty).toFixed(cartDetails.decimalPointValue) }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="product-price">
                  {{ helper.currencySign }}
                </span>
              </div>
              } @if(item.price !== item.discountedPrice){
              <div class="d-flex ms-1 align-items-center original-price">
                <span class="product-price">
                  {{ (item.price * item.qty).toFixed(cartDetails.decimalPointValue) }}
                </span>
                <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="product-price">
                  {{ helper.currencySign }}
                </span>
              </div>
              }
            </div>
            @if(isServicesBusiness && item.maxQtyAddInCart === 1){
            <button class="btn bg-danger-subtle text-danger fw-medium" (click)="decrementProductQuantity(item)">{{ "button-title.remove-product" | translate }}</button>
            } @else{
            <div class="quantity-control">
              <button class="btn btn-sm btn-secondary" (click)="decrementProductQuantity(item)">
                <i class="ri-subtract-line"></i>
              </button>
              <span [@quantityChangeAnimation]="item.qty">{{ item.qty }}</span>
              <button class="btn btn-sm btn-secondary" (click)="incrementProductQuantity(item)" [disabled]="item.qty === item.maxQtyAddInCart">
                <i class="ri-add-line"></i>
              </button>
            </div>
            }
          </div>
        </div>
        <div class="d-flex align-items-center gap-2" [ngClass]="item.modifiers && item.modifiers.length > 0 ? 'justify-content-between' : 'justify-content-end'">
          @if(item.modifiers && item.modifiers.length > 0){
          <span class="product-description">
            {{ formatModifiers(item) | translate }}
          </span>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
<app-promo-code-modal #promoCodeModal (promoApplied)="handlePromoApplied($event)"></app-promo-code-modal>
<app-booking-payment-modal #bookingPaymentModal (selectPaymentEmmiter)="bookingSelectPaymentMethod($event)"></app-booking-payment-modal>
<app-book-for-other-modal #bookForOtherModal [title]="'heading-title.order-for'" (otherCustomerAddEvent)="placeOrder($event)"></app-book-for-other-modal>
